import { Autocomplete, FormLabel, Grid, TextField } from "@mui/material";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useEffect } from "react";
import { useWorkshopCycleStore } from "../../../hooks/useWorkshopCycleStore";
import { WorkshopStudent } from "../../../types/slices/studentType";

export const AddStudentCycleModal: React.FC<{
  onAddStudent: (data: any) => void;
}> = ({ onAddStudent }): JSX.Element | any => {
  const {
    studentsNotInWorkshopCycle,
    selectedStudentsNotInWorkshopCycle,
    selectedWorkshopCycle,
    openModal,
    setOpenModal,
    isEdit,
    getStudentByWorkshopCycle,
    getStudentNotInWorkshopCycle,
    setSelectedStudentsNotInWorkshopCycle,
    createRelationStudentWorkshopCycle,
  } = useWorkshopCycleStore();

  const handleSubmit = async () => {
    setOpenModal(false);
    let idArray: any = selectedStudentsNotInWorkshopCycle.map((obj) => obj.id);
    idArray = JSON.stringify(idArray);
    const response = await createRelationStudentWorkshopCycle(
      selectedWorkshopCycle.id || 0,
      idArray
    );
    if (response === true) {
      getStudentByWorkshopCycle(selectedWorkshopCycle.id || 0).then((data) =>
        onAddStudent(data)
      );
      setSelectedStudentsNotInWorkshopCycle([]);
    }
  };

  useEffect(() => {
    if (openModal) {
      setSelectedStudentsNotInWorkshopCycle([]);
      getStudentNotInWorkshopCycle(selectedWorkshopCycle.id || 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal, selectedWorkshopCycle.id]);

  return (
    <>
      <Modal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        disableEscapeKeyDown
        disableBackdropClick
        size="sm"
      >
        <ModalHeader
          text={"Agregar Alumnos"}
          className="positionElements"
          onCancel={() => setOpenModal(false)}
          // clearState={clearEditeditCycle}
        ></ModalHeader>
        <ModalBody>
          <Grid container>
            <Grid item container xs={12} spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <FormLabel>Alumnos:</FormLabel>
                {studentsNotInWorkshopCycle.length > 0 && (
                  <Autocomplete
                    id="combo-box-course"
                    value={selectedStudentsNotInWorkshopCycle}
                    multiple
                    limitTags={10}
                    options={studentsNotInWorkshopCycle || []}
                    getOptionLabel={(option) =>
                      option?.dni +
                        " - " +
                        option?.name +
                        " " +
                        option?.surname || ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id
                    }
                    fullWidth
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                    onChange={(e, newValue) => {
                      setSelectedStudentsNotInWorkshopCycle(
                        newValue || ([] as WorkshopStudent[])
                      );
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </ModalBody>
        <ModalFooter
          confirmText={isEdit ? "Actualizar" : "Registrar"}
          onConfirm={handleSubmit}
          cancelText={"Cancelar"}
          onCancel={() => {
            setOpenModal(false);
          }}
          className="modal-confirm-footer"
        />
      </Modal>
    </>
  );
};
